<template>
    <section class="wrap_pop">
        <div class="popbox_wrap">
            <div class="popbox_cont type2">
                <img v-if="image=='typing'" src="../../../assets/images/temp/typing.gif" />
                <img v-if="image=='swipe'" src="../../../assets/images/temp/swipe.gif" />
            </div>
            <div class="popbox_btn">
                <div><button type="button" class="btn color1" @click="$emit('close')">확인</button></div>
            </div>
        </div>
    </section>
</template>
<script>
import { ref, onMounted } from 'vue'
export default {
    name: 'ImagePop',
    props: {
        image: String
    },
    setup(props) {
        const test = ref(100)
        return {
            test
        }
    }
}
</script>